module.exports = __webpack_public_path__ + "img/gallery-6.6eb8b2a7.jpg";